<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row dense no-gutters>
      <v-col cols="12" md="6">
        <v-text-field
          dense
          hide-details
          single-line
          outlined
          :prepend-icon="dense ? null : 'person'"
          name="name"
          v-model="form.name"
          :label="$t('delivery.order.labels.name')"
          :placeholder="$t('delivery.order.labels.name')"
          :error="hasInputErrors('name')"
          :error-messages="getInputErrors('name')"
          color="secondary"
          :rules="required"
          required
          class="required"
          autofocus
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          dense
          hide-details
          single-line
          outlined
          :prepend-icon="dense ? null : 'phone'"
          name="phone"
          v-model="form.phone"
          :label="$t('delivery.order.labels.phone')"
          :placeholder="$t('delivery.order.labels.phone')"
          :error="hasInputErrors('phone')"
          :error-messages="getInputErrors('phone')"
          color="secondary"
          :rules="phoneRules"
          :required="!isSalon"
          :class="isSalon ? '' : 'required'"
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          dense
          hide-details
          single-line
          outlined
          :prepend-icon="dense ? null : 'email'"
          name="email"
          v-model="form.email"
          :label="$t('delivery.order.labels.email')"
          :placeholder="$t('delivery.order.labels.email')"
          :error="hasInputErrors('email')"
          :error-messages="getInputErrors('email')"
          color="secondary"
          :rules="emailRules"
          required
          :class="{ required: emailRequired }"
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          dense
          hide-details
          single-line
          outlined
          :rows="dense ? 2 : 2"
          :prepend-icon="dense ? null : 'description'"
          name="observations"
          v-model="form.observations"
          :label="$t('delivery.order.labels.observations')"
          :placeholder="$t('delivery.order.labels.observations')"
          :error="hasInputErrors('observations')"
          :error-messages="getInputErrors('observations')"
          color="secondary"
        ></v-text-field>
      </v-col>

      <v-col v-if="nextButton" cols="12" class="text-right">
        <submit-button
          text="common.next"
          @click="submitContact"
          :disabled="!this.isValid"
        ></submit-button>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { InputErrorsByProps, RequiredRule } from "@dracul/common-frontend";
import { SubmitButton } from "@dracul/common-frontend";

export default {
  name: "BarContactForm",
  mixins: [InputErrorsByProps, RequiredRule],
  components: { SubmitButton },
  props: {
    nextButton: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    emailRequired: { type: Boolean, default: false },
  },
  data() {
    return {
      submitDisabled: true,
      valid: false,
    };
  },

  computed: {
    form: {
      get() {
        return this.$store.getters.orderSystem.order.contact;
      },
      set(val) {
        this.$store.commit("orderContact", val);
      },
    },
    emailRules() {
      return [
        (v) =>
          !this.emailRequired || !!v || this.$t("user.validation.required"),
        (v) =>
          v == "" || /.+@.+/.test(v) || this.$t("user.validation.emailFormat"),
      ];
    },
    phoneRules() {
      return [
        (v) => !!v || this.$t("user.validation.required"),
        (v) =>
          /^(\+)?[0-9]+$/i.test(v) || !v || this.$t("user.validation.number"),
        (v) => !v || v.length >= 8 || "Minimo 8",
      ];
    },
    isValid() {
      return (
        this.valid &&
        this.form.name != "" &&
        (!this.emailRequired || this.form.email != "") &&
        this.form.phone != ""
      );
    },

    isSalon() {
      return this.$store.getters.orderSystem.order.origin === "SALON";
    },
  },
  methods: {
    submitContact() {
      if (this.isValid) {
        this.$emit("next");
      }
    },
  },
};
</script>

<style scoped></style>
